/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-attribute-type.reducer';

export const ProductAttributeTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productAttributeTypeEntity = useAppSelector(state => state.productAttributeType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productAttributeTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.productAttributeType.detail.title">ProductAttributeType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.id">Id</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.active">Active</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.cursor}</dd>
          <dt>
            <span id="title">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.title">Title</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.title}</dd>
          <dt>
            <span id="valueType">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.valueType">Value Type</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.valueType}</dd>
          <dt>
            <span id="valueRange">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.valueRange">Value Range</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.valueRange}</dd>
          <dt>
            <span id="group">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.group">Group</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.group}</dd>
          <dt>
            <span id="productId">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.productId">Product Id</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.productId}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="tinyMedicRestApp.productAttributeType.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{productAttributeTypeEntity.productType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.productAttributeType.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{productAttributeTypeEntity.pharmacy ? productAttributeTypeEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.productAttributeType.parent">Parent</Translate>
          </dt>
          <dd>{productAttributeTypeEntity.parent ? productAttributeTypeEntity.parent.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product-attribute-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product-attribute-type/${productAttributeTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductAttributeTypeDetail;
